module.exports = __webpack_public_path__ + "img/ssl.9f0490bf.svg";